<template>
  <div
    class="py-5 p-st"
    :class="{
      'bg-light': !nightMode,
      'bg-dark2': nightMode,
      'text-light': nightMode,
    }"
  >
    <div class="container">
      <div
        class="text-center"
        data-aos="fade"
        data-aos-once="true"
        data-aos-duration="1000"
      >
        <span
          class="title text-center"
          :class="{ pgray: !nightMode, 'text-light': nightMode }"
          >Contact.</span
        >
      </div>
      <hr
        width="50%"
        :class="{ pgray: !nightMode, 'bg-secondary': nightMode }"
      />
      <br />
      <div
        class="text-center"
        data-aos="fade-up"
        data-aos-once="true"
        data-aos-duration="1000"
      >
        <p
          class="subtitle"
          :class="{ pgray: !nightMode, 'text-light': nightMode }"
        >
          Let's Connect
        </p>
        <button
          @click="openLinkedIn"
          class="mt-1 btn mb-3"
        >
          <i class="fab fa-linkedin mr-2"></i> Message me on LinkedIn
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import info from "../../info";

export default {
  name: "ContactLinkedin",
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  methods: {
    openLinkedIn() {
      window.open(info.links.linkedin, "_blank");
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 30px;
  font-weight: 500;
}

.subtitle {
  font-size: 20px;
  font-weight: 400;
}

.btn {
  border-color: #669db3ff;
  color: #669db3ff;
  width: 50%;
}

.btn:hover {
  background-color: #669db3ff;
  border-color: #669db3ff;
  color: white;
}

.btn:focus {
  background-color: #669db3ff;
  border-color: #669db3ff;
  color: white;
}

@media screen and (max-width: 1000px) {
  .btn {
    width: 90%;
  }
}
</style>
